import { create } from "zustand";

const INITIAL_COLOUR_CODE = "167,167,167";

export const useColourPaletteStore = create((set) => ({
  colourCode: "",
  setColourCode: (colourCode) => set({ colourCode }),
  rgbCode: INITIAL_COLOUR_CODE,
  setRgbCode: (rgbCode) => set({ rgbCode })
}));
